/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Answer } from './Answer';
import {
    AnswerFromJSON,
    AnswerFromJSONTyped,
    AnswerToJSON,
    AnswerToJSONTyped,
} from './Answer';

/**
 * 
 * @export
 * @interface PaginatedAnswerList
 */
export interface PaginatedAnswerList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedAnswerList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedAnswerList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedAnswerList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<Answer>}
     * @memberof PaginatedAnswerList
     */
    results: Array<Answer>;
}

/**
 * Check if a given object implements the PaginatedAnswerList interface.
 */
export function instanceOfPaginatedAnswerList(value: object): value is PaginatedAnswerList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function PaginatedAnswerListFromJSON(json: any): PaginatedAnswerList {
    return PaginatedAnswerListFromJSONTyped(json, false);
}

export function PaginatedAnswerListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedAnswerList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(AnswerFromJSON)),
    };
}

  export function PaginatedAnswerListToJSON(json: any): PaginatedAnswerList {
      return PaginatedAnswerListToJSONTyped(json, false);
  }

  export function PaginatedAnswerListToJSONTyped(value?: PaginatedAnswerList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(AnswerToJSON)),
    };
}

